import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FeaturedIcon } from '@backrs_ui/common-ui/src/designSystem/icons/FeaturedIcon';
import { Box, Typography, Stack } from '@mui/material';
import { InfoModal } from '../InfoModal';
var BodyBox = function (_a) {
    var section = _a.section;
    return (_jsxs(Box, { sx: bodyBoxContainerSx, children: [_jsx(FeaturedIcon, { iconName: section.iconName, size: "lg", color: "Colors/Base/White", backgroundColor: section.color, shape: "round" }), _jsxs(Stack, { children: [_jsxs(Box, { children: [_jsx(Typography, { component: "span", color: function (theme) { return theme.backrs.colors['Gray/700']; }, variant: "text-md-bold", children: section.title }), ' ', _jsx(Typography, { component: "span", variant: "text-sm-regular", sx: subtitleSx, children: section.subtitle })] }), _jsx(Typography, { color: function (theme) { return theme.backrs.colors['Gray/600']; }, variant: "text-sm-regular", children: section.content })] })] }));
};
var BodyContent = function (_a) {
    var sections = _a.sections;
    return (_jsx(Box, { sx: bodyContentContainerSx, children: sections.map(function (section) { return (_jsx(BodyBox, { section: section }, section.title)); }) }));
};
var HeaderContent = function (_a) {
    var data = _a.data;
    return (_jsxs(Box, { sx: headerContentContainerSx, children: [_jsx(Typography, { color: function (theme) { return theme.backrs.colors['Gray/900']; }, variant: "text-lg-semibold", children: data.title }), _jsx(Typography, { color: function (theme) { return theme.backrs.colors['Colors/Base/Black']; }, variant: "text-sm-regular", children: data.description })] }));
};
export var ChartCardModal = function (_a) {
    var isModalOpen = _a.isModalOpen, setIsModalOpen = _a.setIsModalOpen, modalData = _a.modalData;
    return (_jsx(InfoModal, { open: isModalOpen, onClose: function () { return setIsModalOpen(false); }, headerContent: _jsx(HeaderContent, { data: modalData }), bodyContent: _jsx(BodyContent, { sections: modalData.modalCards }) }));
};
var bodyBoxContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        padding: backrs.spacing['spacing-xl'],
        gap: backrs.spacing['spacing-lg'],
        borderRadius: backrs.radius['radius-xl'],
        border: "1px solid ".concat(backrs.colors['Gray/200']),
    });
};
var subtitleSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        fontStyle: 'italic',
        color: backrs.colors['Gray/600'],
    });
};
var headerContentContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        gap: backrs.spacing['spacing-xxs'],
    });
};
var bodyContentContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-lg'],
    });
};
